const LikeIcon = ({ size = 14, ...props }) => {
    return (
        <svg width={size} height={size} viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <path 
                fillRule="evenodd" 
                clipRule="evenodd" 
                d="M2.17493 6.76569C1.54901 4.81152 2.28051 2.57794 4.3321 1.91702C5.41126 1.56877 6.60243 1.7741 7.4996 2.44902C8.34835 1.79277 9.58326 1.5711 10.6613 1.91702C12.7128 2.57794 13.449 4.81152 12.8237 6.76569C11.8495 9.86319 7.4996 12.249 7.4996 12.249C7.4996 12.249 3.18176 9.89935 2.17493 6.76569Z" 
                fill="white" 
                stroke="white" 
                strokeWidth="0.875" 
                strokeLinecap="round" 
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default LikeIcon;